import IDocumentTemplate from "../typings/Documents/IDocumentTemplate";
import IIssuedAct from "../typings/Documents/IIssuedAct";
import http from "./client";
import { IListResponse } from "./types";


async function save(document: Partial<IDocumentTemplate>, courseId: string | number): Promise<IDocumentTemplate> {
  const resp = await http.post('/api/documents/template-save',document, {
    params: {
      course_id: courseId,
    }
  });
  return resp.data.data;
}

async function byId(id: string | number, courseId: string | number): Promise<IDocumentTemplate> {
  const resp = await http.get('/api/documents/template-by-id', {
    params: {
      id,
      course_id: courseId,
    }
  });

  return resp.data.data;
}

async function templateList(courseId: string | number, withStudentsCount: boolean): Promise<IListResponse<IDocumentTemplate>> {
  const response = await http.get("/api/documents/template-list", {
    params: {
      course_id: courseId,
      withStudentsCount,
    }
  });
  return response.data;

}

async function remove(id: string | number, courseId: string | number) {
  const resp = await http.post('/api/documents/template-delete', {
    id,
    course_id: courseId,
  })
}

/**
 * Возвращает список выданных актов
 * @param docId 
 * @param courseId 
 * @param page
 * @param search 
 */
async function list(docId: string | number, courseId: string | number, page: number = 1, search?: string): Promise<IListResponse<IIssuedAct>> {
  const resp = await http.get('/api/documents/list', {
    params: {
      id: docId,
      course_id: courseId,
      page,
      search
    }
  });
  return resp.data;
}


async function create(docId: string | number, courseId: string | number, students: Array<number>) {
  const resp = await http.post('/api/documents/create', {
    students: students
  }, {
    params: {
      course_id: courseId,
      id: docId,
    }
  })
}


async function exportActs(docId: string | number, courseId: string | number) {
  await http.post('/api/documents/export',undefined, {
    params: {
      course_id: courseId,
      id: docId,
    }
  })
}

async function generatePreview(courseId: string | number, doc: Partial<IDocumentTemplate>): Promise<string> {
  const res = await http.post('/api/documents/template-preview', doc, {
    params: {
      course_id: courseId
    }
  });
  return res.data.preview;
}

async function templatesByCourse(courseId: string | number,) {
 const res = await http.get('/api/documents/template-by-course',{
  params: {
    course_id: courseId
  }
 });

 return res.data.data;
}

export const documents = {
  save, byId, templateList, list, remove, create, exportActs, generatePreview, templatesByCourse
}

export default documents;